import { render } from "./ElementImage.vue?vue&type=template&id=b28ae71a&scoped=true"
import script from "./ElementImage.vue?vue&type=script&lang=js"
export * from "./ElementImage.vue?vue&type=script&lang=js"

import "./ElementImage.vue?vue&type=style&index=0&id=b28ae71a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b28ae71a"]])

export default __exports__